/*
 * Attention
 * @module components
 * @flow
 */

import styled from 'styled-components/macro';
import { palette } from 'styled-theme';

export type AttentionProps = {
  children?: React$Node,
  palette?: string,
};

export const Attention = styled.div`
  padding: 8px 10px;
  color: ${palette(1)};
  background-color: ${palette(0, true)};
  border: 1px solid currentColor;
  border-radius: 6px;
  font-size: 11px;
  box-sizing: border-box;
`;

Attention.defaultProps = {
  palette: 'primary',
};
